module.exports = __webpack_public_path__ + "static/media/AutonomiQ_AI_image.c708cf90.svg";